import { render, staticRenderFns } from "./consult_list.vue?vue&type=template&id=6db5611e"
import script from "./consult_list.vue?vue&type=script&lang=js"
export * from "./consult_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports